
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import SystemService from '@/services/system.service';

@Component({})
export default class CertificateAddressDistanceField extends Vue {
  val: string | number | boolean = '';

  @lazyInject(SystemService)
  protected SystemService!: SystemService;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  value!: any;

  certificateAddressDistance: any = '';

  @Watch('value')
  watchValue() {
    if (this.value == null) {
      this.val = '';
      return;
    }
    if (
      typeof this.value === 'string' ||
      typeof this.value === 'number' ||
      typeof this.value === 'boolean'
    ) {
      this.val = this.value;
      return;
    }
    this.val = JSON.stringify(this.value);
  }
  async getRule() {
    const getRule = await this.SystemService.getRule(
      'certificate_address_distance_key',
    );
    this.certificateAddressDistance = getRule;
  }

  mounted() {
    this.watchValue();
    this.getRule();
  }
}
